// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"38510ce6","238":"8cc09048","455":"ebaf6c79","644":"e691bccc","865":"138420d3"}[chunkId] + ".chunk.js";
};